<template>
  <crud-layout-search
    ref="crudLayoutSearch"
    :params="params"
    :interface="nmInterface"
    :id="id"
    :page="page"
    clean-layout
    class="clientCarrier"
  >
      <page-table
              slot="page-table"
              slot-scope="dataPageTable"
              v-bind="dataPageTable"
              @action-button="dataPageTable.actionButton"
              @show-message="dataPageTable.showMessage"
            >
            <template
                slot="table"
                slot-scope="dataTable" >
              <jt-data-table
                v-bind="dataTable"
                multiselect
                selection-force
                :columnEdit="columnEdit"
                class="table-crud"
                :row-buttons="false"
                @selection="_event => onSelectRow(_event)"
                @action-button="(_event, _clickedRecord, _jtDataTableComponent) => onActionClick(_event, _clickedRecord, _jtDataTableComponent, dataTable.actionButton)"
              >
              </jt-data-table>
            </template>
      </page-table>
  </crud-layout-search>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDataTable } from 'jtech-webcomps'
import ClientCarrierPage from './ClientCarrierPage'
import ClientCarrierDetailPage from './ClientCarrierDetailPage'
import ClientGeneratorResidueDialog from '../client-generator/ClientGeneratorResidueDialog.vue'
import { repository } from 'jtech'

const { CrudLayoutSearch, pageTable, page } = JtCrud
@Component({
  name: 'ClientCarrier',
  mixins: [page],
  components: { CrudLayoutSearch, ClientCarrierPage, JtDataTable, pageTable, page },
  props: {
    id: String,
    interface: String,
    name: String,
    params: Object
  }
})
class ClientCarrier extends Vue {
  idsToActivateOrInactivate = []
  dataTable = []

  get nmInterface () {
    return this.interface
  }

  get page () {
    return ClientCarrierPage
  }

  async icActivateInBlock (button) {
    this.dialogUpdateAvailableInBlock(true)
  }

  async icInactivateInBlock (button) {
    this.dialogUpdateAvailableInBlock(false)
  }

  columnEdit ({ col, props }) {
    switch (col.name) {
      case 'carrierName':
        return `<span>${props.row.carrierName}</span>
                <br>
                <small>${props.row.documentCarrier}</small>`
      case 'generator':
        return `<span>${props.row.generator}</span>
                <br>
                <small>${props.row.documentGenerator}</small>`
    }
  }

  mounted () {
    try {
      this.$refs.crudLayoutSearch.onButton('icActivateInBlock', this.icActivateInBlock)
      this.$refs.crudLayoutSearch.onButton('icInactivateInBlock', this.icInactivateInBlock)
    } catch (error) {
      console.error(error)
    }
  }

  onSelectRow (_event) {
    this.idsToActivateOrInactivate = []
    _event.forEach(_selectedRecord => {
      this.idsToActivateOrInactivate.push(_selectedRecord.id)
    })
  }

  dialogUpdateAvailableInBlock (available) {
    if (this.idsToActivateOrInactivate.length == 0) {
      this.$q.dialog({
        title: this.$gettext('IS_CLIENTE_GENERATOR_RESIDUE_AVAILABLE_BLOCK_NO_REGISTERS'),
        component: ClientGeneratorResidueDialog,
        parent: this,
        confirm: false
      })
      return
    }

    const title = this.$gettextInterpolate(this.$gettext('IS_CLIENTE_GENERATOR_RESIDUE_AVAILABLE_BLOCK'), { action: (available ? this.$gettext('ACTIVATE_MSG') : this.$gettext('INACTIVATE_MSG')) })
    this.$q
      .dialog({
        title: title,
        component: ClientGeneratorResidueDialog,
        parent: this,
        confirm: true
      })

      .onOk(async () => {
        const param = {
          available: available,
          ids: this.idsToActivateOrInactivate
        }
        await repository.resolveLogic(
          'clientCarrier.updateAvailableInBlock',
          param
        )
        this.$refs.crudLayoutSearch.refresh()
      })
  }

  onActionClick (_event, _clickedRecord, _jtDataTableComponent, _actionButton) {
    const { name, label } = _event
    if (name == 'icDetalhar' || name == 'icAlterar') {
      _actionButton(_event, _clickedRecord, _jtDataTableComponent)
    }
  }
}
export default ClientCarrier
</script>
<style lang="stylus" scoped>
.clientCarrier{
  padding-top: 20px;

  .buttons-top-crud{
    display: none;
  }

  .label-crud-search{
    display: none;
  }

  .btNovo-btn i,
  .icAlterar-btn i,
  .icAtivar-btn i,
  .icInativar-btn i {
    padding-right: 10px;
  }

  .crudButtons .card-crud .table-crud .jt-datatable{
    height: 63vh!important;
  }
}
</style>
